import { BOOKING_TIME_ZONE } from "./bookingTimeZone";
import type { BookingCustomer, CreatePublicBookingRequest, Household, SlotReservation } from "./publicBookingFlowTypes";

export function buildCreateBookingPayload(bookingCustomer: BookingCustomer, householdData: Household, slotData: SlotReservation): CreatePublicBookingRequest {
  const metadata: Record<string, string> = {
  };

  return {
    eventTypeSlug: slotData.eventTypeSlug,
    teamSlug: slotData.teamSlug,
    start: slotData.slotStart,
    attendee: {
      name: `${bookingCustomer.firstName} ${bookingCustomer.lastName}`.trim(),
      email: bookingCustomer.email,
      phoneNumber: bookingCustomer.phone,
      timeZone: BOOKING_TIME_ZONE,
      // All three sent when given, all three omitted when blank, and blank is a perfectly ordinary
      // answer for any of them. The server encrypts the SSN into a vault row and keeps only a pointer
      // and a keyed token on the booking, so what travels here is the last place the digits exist in
      // the clear.
      //
      // The energy account number used to stay behind, because nothing server-side asked for it. It
      // does now: AmsBookingRequests.EnergyAccountNumber, which is what the staff appointment dialog
      // reads. Collecting an answer and then discarding it in the browser was the worst of both — the
      // applicant was asked for it and nobody could ever see what they said.
      dateOfBirth: bookingCustomer.dateOfBirth || undefined,
      ssn: bookingCustomer.ssn || undefined,
      energyAccountNumber: bookingCustomer.energyAccountNumber || undefined,
      // The consent the checkbox on step 1 collects. Sent explicitly rather than left undefined when
      // unticked: the server treats a missing value as "no", and stating it keeps the wire body an
      // honest record of what the applicant was shown and what they answered.
      smsOptIn: bookingCustomer.smsOptIn === true,
    },
    household: {
      address: householdData.address,
      // Omitted, not sent as zero, when the household step did not ask (AmsBookingWithoutIncome,
      // AB#840): zero is a real answer, and the server tells the two apart.
      ...(householdData.householdIncome === undefined ? {} : { householdIncome: householdData.householdIncome }),
      householdSize: householdData.householdSize,
      energySource: householdData.energySource,
      pseService: householdData.pseService
    },
    metadata,
    reservationUid: slotData.reservationUid,
  };
}
